import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e31adfd8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "goods-info" }
const _hoisted_2 = { class: "goods-info-left" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "goods-info-right" }
const _hoisted_5 = { class: "goods-title" }
const _hoisted_6 = { class: "goods-attr" }
const _hoisted_7 = { class: "goods-attr-item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "attr-left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "brand-name" }, "品牌"),
  /*#__PURE__*/_createElementVNode("span", null, "：")
], -1))
const _hoisted_9 = { class: "attr-right" }
const _hoisted_10 = { class: "goods-attr-item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "attr-left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "brand-name" }, "型号"),
  /*#__PURE__*/_createElementVNode("span", null, "：")
], -1))
const _hoisted_12 = { class: "attr-right" }
const _hoisted_13 = { class: "goods-attr-item" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "attr-left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "brand-name" }, "单价"),
  /*#__PURE__*/_createElementVNode("span", null, "：")
], -1))
const _hoisted_15 = { class: "attr-right" }
const _hoisted_16 = { class: "goods-attr-item" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "attr-left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "brand-name" }, "采购量"),
  /*#__PURE__*/_createElementVNode("span", null, "：")
], -1))
const _hoisted_18 = { class: "attr-right" }
const _hoisted_19 = { class: "goods-attr-item" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "attr-left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "brand-name" }, "总价"),
  /*#__PURE__*/_createElementVNode("span", null, "：")
], -1))
const _hoisted_21 = { class: "attr-right" }

import { inject, ref } from "vue"
import { OrderGoodsType } from "@/utils/apitype/goodsType"
interface Props {
	goods: OrderGoodsType
}

export default /*#__PURE__*/_defineComponent({
  __name: 'GoodsMoreSelect',
  props: {
    goods: null
  },
  setup(__props: any) {

const { goods } = __props as {
	goods: OrderGoodsType
};


let staticUrl = inject("staticUrl", "https://img2.sjyuan.net.cn/")

let changeUrl = (val: any) => {
	if (val.startsWith("https")) {
		return val
	} else {
		return staticUrl + val
	}
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("view", _hoisted_1, [
    _createElementVNode("view", _hoisted_2, [
      _createElementVNode("img", {
        class: "goods-img",
        src: _unref(changeUrl)(__props.goods.photo)
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("view", _hoisted_4, [
      _createElementVNode("p", _hoisted_5, _toDisplayString(__props.goods.names), 1),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, _toDisplayString(__props.goods.brand), 1)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, _toDisplayString(__props.goods.model), 1)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, _toDisplayString(__props.goods.price), 1)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, _toDisplayString(__props.goods.numbers), 1)
        ]),
        _createElementVNode("div", _hoisted_19, [
          _hoisted_20,
          _createElementVNode("div", _hoisted_21, _toDisplayString(__props.goods.price * __props.goods.numbers), 1)
        ])
      ])
    ])
  ]))
}
}

})